import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSlideTallAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSlideTallAdd"><Path fillRule="evenodd" clipRule="evenodd" d="M20 22H4V2H20V22ZM8 11.25V12.75H11.25V16H12.75V12.75H16V11.25H12.75V8H11.25V11.25H8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSlideTallAdd;
